import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		root: {
		},
		title: {
			color: baseColors.black,
			...{ fontSize: 24, fontWeight: 600 },
		},
		action: {
			marginTop: 0,
		},
		buttonTitle: {
			color: theme.palette.primary.contrastText,
		},
		linebreak: {
			overflowWrap: "break-word",
			wordWrap: "break-word",
			hyphens: "auto",
		}
	} satisfies Record<string, CSSObject>;
};
